export const MarketSymbols = {
    MarketService: Symbol.for("MarketService"),
    MarketProvider: Symbol.for("MarketProvider")
}